import type { enPlan } from "./en.plan";

/** Russian for the org's plan and the first steps of an empty org (see `en.plan.ts`). */
export const ruPlan: Record<keyof typeof enPlan, string> = {
  "plan.meter.tracker.campaigns": "Кампании",
  "plan.meter.tracker.domains": "Домены",
  "plan.feature.tracker.reports.custom": "Свои отчёты — сохранённые виды и формулы",
  "plan.feature.tracker.postbacks.s2s": "S2S-постбеки партнёрок",
  "plan.usage": "{meter}: {used} из {limit} по тарифу",
  "plan.usage.full": "{meter}: {used} из {limit} — лимит тарифа исчерпан",
  "plan.increase": "Увеличить",
  "plan.billing": "Тариф и оплата",
  "plan.connect": "Подключить",
  "plan.refusal.limit": "Лимит тарифа исчерпан: {meter} — {limit}",
  "plan.refusal.limitPlain": "Лимит тарифа исчерпан: {meter}",
  "plan.refusal.limit.hint": "Увеличьте тариф, чтобы добавить ещё, — введённое не потеряется.",
  "plan.refusal.feature": "«{feature}» не входит в ваш тариф",
  "plan.refusal.feature.hint": "Доступно в тарифе выше — откройте «Тариф и оплата».",
  "plan.refusal.product": "{product}: продукт не подключён к организации",
  "plan.refusal.suspended": "Организация приостановлена — продукты закрыты до оплаты",
  "plan.refusal.ambiguous": "Выберите организацию, чтобы продолжить",
  "plan.refusal.lockedBySource": "Кампания управляется во внешнем источнике",
  "onb.domain": "Домен для рекламных ссылок",
  "onb.domain.todo": "Рекламная ссылка живёт на вашем домене: подключите свой записью CNAME или купите новый и подключите его.",
  "onb.domain.done": "{fqdn} — {state}",
  "onb.domain.own": "Свой домен",
  "onb.domain.buy": "Купить домен",
  "onb.buy.title": "Купить домен",
  "onb.buy.body": "Купите домен у любого регистратора или возьмите поддомен домена, который у вас уже есть (go.example.com). Затем подключите его здесь: трекер покажет запись CNAME для вашего DNS и будет проверять её каждую минуту.",
  "onb.buy.connect": "Домен есть — подключить",
  "onb.campaign": "Первая кампания",
  "onb.campaign.todo": "Источник, оффер и домен — редактор проведёт по шагам и закончит рекламной ссылкой.",
  "onb.campaign.create": "Создать кампанию",
  "onb.readOnly": "Попросите администратора организации подключить первый домен.",
};
